import { createAction } from "@actionCreator";
import { AppEventFired } from "@modules/app-events/constants/actions";

export const fireEvent = createAction(AppEventFired);
